import * as React from "react";
import clx from "classnames";
import styles from './style.module.scss'

type Props = {
  size?: 'sm' | 'md' | 'lg' | number
  className?: string
}

export const Spinner = ({ size = 'md', className }: Props) => (
  <div className={clx(styles.etSpinner, "tw-inline-block tw-aspect-square",
    "tw-animate-spin tw-rounded-full",
     {
    "tw-w-6 tw-h-6": size === 'sm', //24
    "tw-w-8 tw-h-8": size === 'md', //40
    "tw-w-10 tw-h-10": size === 'lg', //64
    [`tw-w-${size} tw-h-${size}`]: typeof size === 'number',
  }, className)} />
);
